import { observer } from 'mobx-react';
import React from 'react';
import { Modal } from '../../UI/modal/Modal';
import greenCheckmarkIcon from '../../../assets/icons/checkmark_green_icon.png';
import { Button } from '../../UI/buttons/regular/Button';
import styles from './AdditionAcivatedModal.module.scss';

export const AdditionAcivatedModal = observer((props: any) => {
  const { currentPage } = props;
  const closeModal = () => {
    currentPage.getAdditionActivatedModal().setOpened(false);
  };
  return (
    <Modal
      styles={{
        overlay: {
          backgroundColor: 'rgba(0, 35, 63, 0.5)',
          border: '1px solid #707070',
        },
        content: {
          opacity: '1',
        },
      }}
      model={currentPage.getAdditionActivatedModal()}
    >
      <div className={styles.ModalContent}>
        <img
          className={styles.Checkmark}
          src={greenCheckmarkIcon}
          alt="check"
        />
        <p>Uspešno ste aktivirali dodatak.</p>
        <div className={styles.Button}>
          <Button
            model={{
              id: 'ok',
              label: 'OK',
              isEnabledComputed: true,
            }}
            onClick={closeModal}
          />
        </div>
      </div>
    </Modal>
  );
});
